import { motion } from "framer-motion";
import { MaskedLines, Eyebrow } from "@/components/Motion";

const PageHero = ({ eyebrow, lines, accentIndex = -1, children, testId }) => (
  <section data-testid={testId} className="relative bg-bone pt-40 pb-20 lg:pt-52 lg:pb-28 overflow-hidden">
    <div className="absolute -top-24 -right-24 w-[28rem] h-[28rem] rounded-full bg-pine-100/60 blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <Eyebrow>{eyebrow}</Eyebrow>
      </motion.div>
      <MaskedLines
        lines={lines}
        className="mt-8 font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[1.02] text-pine-950 max-w-4xl"
        lineClassName=""
        delay={0.2}
      />
      {children && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mt-8 max-w-2xl text-sage text-base lg:text-lg leading-relaxed"
        >
          {children}
        </motion.div>
      )}
    </div>
  </section>
);

export default PageHero;
